import PublicNavbar from "@/components/feature/PublicNavbar";
import HeroSection from "./components/HeroSection";
import ConvivenciaEscolarSection from "./components/ConvivenciaEscolarSection";
import EquiposPsicosocialesSection from "./components/EquiposPsicosocialesSection";
import GestionCasosSection from "./components/GestionCasosSection";
import IAInstitucionalSection from "./components/IAInstitucionalSection";
import CTASection from "./components/CTASection";
import FooterSection from "./components/FooterSection";
import { useScrollProgress } from "@/hooks/useScrollReveal";

export default function LandingPage() {
  useScrollProgress();

  return (
    <div className="min-h-screen bg-background-50">
      <div className="scroll-progress">
        <div id="scroll-progress-bar" className="scroll-progress-bar" />
      </div>

      <PublicNavbar />
      <main>
        <HeroSection />
        <ConvivenciaEscolarSection />
        <EquiposPsicosocialesSection />
        <GestionCasosSection />
        <IAInstitucionalSection />
        <CTASection />
      </main>
      <FooterSection />
    </div>
  );
}